<template>
  <div>
    <el-input
      v-if="showSearch"
      v-model="filterText"
      size="small"
      class="filter-input"
      placeholder="输入关键字搜索部门"
    />
    <el-tree
      ref="tree"
      :filter-node-method="filterNode"
      v-bind="$attrs"
      class="customerTree"
      :check-strictly="true"
    >
      <span slot-scope="{ node }" class="custom-tree-node">
        <el-checkbox
          v-model="node.checked"
          class="checkBox"
          :disabled="node.disabled"
          @change="(checked) => checkChange(checked, node)"
        />
        <i>{{ node.label }}</i>
      </span>
    </el-tree>
  </div>
</template>

<script>
export default {
  name: 'CustomTree',
  props: {
    showSearch: {
      type: Boolean, // 是否显示搜索
      default: true
    },
    childernFollowParent: {
      type: Boolean, // 子节点勾选是否跟随父节点
      default: false
    },
    showRange: {
      type: Boolean, // 可见范围
      default: true
    }
  },
  data() {
    return {
      filterText: ''
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    }
  },
  mounted() {
  },
  methods: {
    filterNode(value, data) {
      if (data.notShow) {
        return false
      }
      if (!value) return true
      return data.value.indexOf(value) !== -1
    },
    clearSearch() {
      this.filterText = ''
    },
    // 搜索值
    filterOrg(val) {
      this.filterText = val
    },
    async init({ departmentList }, callback) {
      this.$refs.tree.filter(this.filterText)
      await this.$nextTick()
      this.$refs.tree.setCheckedKeys(departmentList.map(i => i.id))
      this.checkChange(null, null, callback)
    },
    async checkChange(checked, node, callback = () => {}) {
      // 如果父级选择子集必须选择，子集全选父级也可以不选
      if (this.childernFollowParent && node !== null && node.parent !== undefined && node.parent.checked !== undefined && node.parent.checked) {
        checked = node.parent.checked
      }

      if (node) this.setChildrentCheck([node], checked)
      // if (node.parent && node.parent.childNodes && node.parent.childNodes.every(i => i.checked)) {
      //   node.parent.checked = true
      // }
      this.$nextTick(async() => {
        const data = await this.checkData()
        this.$emit('update:departmentList', data)
        // console.log('孙子组件===departmentList', data)
        this.$nextTick(() => {
          callback && callback(data)
        })
        this.$emit('input', this.$refs.tree.getCheckedKeys())
      })
    },
    setChildrentCheck(node, checked) {
      const nodeList = []
      node.forEach(i => {
        // console.log('setChildrentCheck',i.data.value,i.data.visible,i.data.disabled,i.data.disabled === false)
        if (i.data && i.data.disabled === false) {
          i.checked = checked
          // 当部门不可选的时候，令其永远是非选中状态
          if (this.showRange && i.data.visible === false) {
            i.checked = false
          }
          if (i.data.id) {
            nodeList.push(i.data.id)
          }
        }
        if (i.childNodes && i.childNodes.length) {
          this.setChildrentCheck(i.childNodes, checked)
        }
      })
      if (checked === false) {
        let keys = this.$refs.tree.getCheckedKeys()
        keys = keys.filter((item) => !nodeList.includes(item))
        this.$refs.tree.setCheckedKeys(keys)
      }
    },
    getRootNode() {
      return new Promise((reslove, reject) => {
        const getNode = () => {
          const node = this?.$refs?.tree?.root?.childNodes
          if (!node.length) {
            setTimeout(() => {
              getNode()
            })
          } else {
            reslove(node)
          }
        }
        getNode()
      })
    },
    async checkData() {
      await this.$nextTick()
      const nodeKey = this.$attrs['node-key']
      const { label } = this.$attrs.props || { label: 'label' }
      // const allNodes = [...(this.$refs.tree.checkboxItems || [])]
      // const allNodes = this.$refs.tree.root.childNodes || []
      const allNodes = await this.getRootNode()
      // console.log(allNodes)
      // const checkAll = allNodes.every(i => i.checked)
      const result = this.checkedData(allNodes)
      return result.map(i => {
        return {
          [nodeKey]: i.key,
          [label]: i.label,
          node: i,
          del: i.del ? i.del : (callback) => {
            this.checkChange(false, i, callback)
          }
        }
      })
      // console.log(this.$refs.tree)
      // if (checkAll) {
      //   return this.$refs.tree.root.childNodes.map(i => {
      //     console.log(i)
      //     return {
      //       [nodeKey]: i.key,
      //       [label]: i.label
      //     }
      //   })
      // } else {
      //   console.log(this.$refs.tree.getCheckedNodes())
      //   return this.$refs.tree.getCheckedNodes().map(i => {
      //     console.log(i)
      //     return {
      //       [nodeKey]: i[nodeKey],
      //       [label]: i[label]
      //     }
      //   })
      // }
    },
    checkedData(node) {
      let result = []
      node.forEach(i => {
        if (!this.childrenCheckedAll([i])) {
          if (i.checked) {
            result = [...result, i]
          }
          result = [...result, ...this.checkedData(i.childNodes)]
        } else if (i.checked) {
          result.push(i)
        }
      })
      return result
    },
    // 子集是否全选
    childrenCheckedAll(node) {
      return node.reduce((p, n) => {
        if (!n.checked || (n.childNodes && !this.childrenCheckedAll(n.childNodes))) return false
        return p
      }, true)
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-input {
  width: 240px;
  margin-top: 10px;
  margin-left: 10px;
}
.customerTree{

  .checkBox{
    margin-right: 8px;
  }
  /deep/.el-tree-node__expand-icon{
    margin-right: 2px;
  }
}
</style>
